export default "__VITE_ASSET__BRiPL9DS__"